import axios from 'axios';

export default class BookingService {
	constructor(client) {
		this.url = '/clients-webservice';
		if(client) {
			this.auth = {
				username: client.login,
				password: client.key
			}
			this.clientOperatorId = client.clientOperatorId;
		}
	}

	save(fileRequest) {
		fileRequest.origin = "ONLINE_RESERVATIONS";
		if (this.clientOperatorId !== undefined && this.clientOperatorId !== null)
			fileRequest.clientOperatorId = this.clientOperatorId;
    return axios.post(`${this.url}/${fileRequest.type}s/bookings`, fileRequest, { auth:this.auth });
	}

	cancelFile(fileNumber) {
		return axios.put(`${this.url}/files/${fileNumber}/cancel`, null, { auth:this.auth });
	}

	confirm(fileNumber) {
		return axios.put(`${this.url}/files/${fileNumber}/confirm`, null, { auth:this.auth });
	}

	filterFiles(filter) {
		return axios.get(`${this.url}/files`, { auth:this.auth, params: filter });
	}

	getVoucherPdf(fileNumber) {
		return axios.get(`${this.url}/files/${fileNumber}/voucher`, { auth: this.auth, responseType: 'arraybuffer' });
	}

	getYourBookingPdf(fileNumber) {
		return axios.get(`${this.url}/files/${fileNumber}/your-booking`, { auth: this.auth, responseType: 'arraybuffer' });
	}

	getInvoicePdf(fileNumber) {
		return axios.get(`${this.url}/files/${fileNumber}/invoice`, { auth: this.auth, responseType: 'arraybuffer' });
	}
}



// WEBPACK FOOTER //
// ./src/services/BookingService.js